import { FormEvent, useEffect, useRef, useState } from "react";
import { useConfig } from "../../contexts/config.context";
import { Send } from "lucide-react";
import { ChatItem } from "../types";
import ThinkingBubbles from "../thinking-bubbles";

const ChatInterface2 = (
  {
    handleSubmitTextInput,
    chatHistory,
    isThinking,
    animate = false,
  }: {
    handleSubmitTextInput: (value: string) => void;
    chatHistory: ChatItem[],
    isThinking?: boolean;
    animate?: boolean;
  }) => {
  const { config } = useConfig();
  const [displayTextLen, setDisplayTextLen] = useState<number>(0);

  const [textInput, setTextInput] = useState('');

  const lastMessageElRef = useRef<HTMLSpanElement>(null);
  const timerRef = useRef<NodeJS.Timeout>(null);

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (!textInput.trim()) return;
    handleSubmitTextInput(textInput);
    setTextInput('');
  };

  // useEffect(() => {
  //   {/*eslint-disable-next-line @typescript-eslint/no-explicit-any*/ }
  //   function handleNewMessage(event: any) {
  //     log('handleNewMessage::config', config)
  //     // setChatHistory(p => [...p, { role: event.role, text: event.text }])
  //
  //     const tx = setTimeout(() => {
  //       lastMessageElRef.current?.scrollIntoView({ behavior: "smooth", block: "center" })
  //       clearTimeout(tx)
  //     }, 50)
  //   }
  //
  //   chatEventsEmitter.on('message', handleNewMessage)
  //
  //   return () => {
  //     chatEventsEmitter.off('message', handleNewMessage)
  //   }
  // }, []);

  const TYPING_DELAY_MS = 25;

  useEffect(() => {
    const message = chatHistory[chatHistory.length - 1];

    const tx = setTimeout(() => {
      lastMessageElRef.current?.scrollIntoView({ behavior: "smooth", block: "center" })
      clearTimeout(tx)
    }, 50)

    if (message?.role !== "user" && message?.text && animate) {
      setDisplayTextLen(0);

      if (timerRef.current) {
        clearInterval(timerRef.current)
        timerRef.current = null;
      }

      timerRef.current = setInterval(() => {
        setDisplayTextLen(p => {
          let nx = p + 1
          if (nx < message.text.length) {
            return nx;
          } else {
            if (timerRef.current) {
              clearInterval(timerRef.current);
            }
            return message.text.length;
          }
        });
      }, TYPING_DELAY_MS);
    }

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current)
        timerRef.current = null;
      }
    } // Cleanup timer
  }, [chatHistory]);

  return (
    <div className="!h-full !w-full !flex !flex-col !justify-between">
      <div className="!flex-1 !overflow-y-auto !space-y-4 !max-h-[300px] !no-scrollbar">
        {chatHistory.map((msg, index) => (
          <div key={index} className={`!flex ${msg.role === "user" ? "!justify-end" : "!justify-start"}`}>
            {msg.role !== "user" && (
              <div className="!w-8 !h-8 !rounded-full !bg-[var(--sonaris-color-primary)]/60 !flex !items-center !justify-center !text-xs !font-bold !text-white !mr-2">
                {(config?.remote?.character?.name || "Jenna")[0]}
              </div>
            )}
            <div
              className={`!px-4 !py-2 !rounded-xl !text-sm !max-w-[70%] ${msg.role === "user" ? "!bg-[var(--sonaris-color-primary)]/30 !text-white !break-words" : "!bg-white !text-black"}`}
            >
              {animate && msg.role !== 'user' && index === chatHistory.length - 1 ? msg.text.substring(0, displayTextLen) : msg.text}
            </div>
            {msg.role === "user" && (
              <div className="!w-8 !h-8 !rounded-full !bg-[var(--sonaris-color-primary)]/40 !flex !items-center !justify-center !text-xs !font-bold !text-white !ml-2 !flex-wrap">
                U
              </div>
            )}
          </div>
        ))}
        {
          isThinking && (
            <div className={`!flex !justify-start`}>
              <div className="!w-8 !h-8 !rounded-full !bg-[var(--sonaris-color-primary)]/60 !flex !items-center !justify-center !text-xs !font-bold !text-white !mr-2">
                {(config?.remote?.character?.name || "AI")[0]}
              </div>
              <ThinkingBubbles />
            </div>
          )
        }
        <span ref={lastMessageElRef} />
      </div>
      <div className="pt-4">
        <form onSubmit={handleSubmit}
          className="!flex !items-center !gap-2 !bg-[var(--sonaris-color-primary)]/20 !rounded-full !px-4 !py-2">
          <input
            type="text"
            value={textInput}
            onChange={(e) => setTextInput(e.target.value)}
            placeholder="Type your message..."
            className="!flex-1 !text-sm !outline-none !text-white !bg-none !bg-transparent !border-none !m-0 !p-0 focus:!border-none focus:!outline-none"
          />

          <button disabled={!textInput} className="!text-white/80 !hover:text-white !transition-all">
            <Send size={18} />
          </button>
        </form>
      </div>
    </div>
  )
}

export default ChatInterface2;
